import React from 'react';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import { Box, IconButton } from '@mui/material';

import { AngleField } from '@paragon/material';

interface DocumentRotationFieldProps {
  disabled?: boolean;

  value: number;
  onSubmit: (rotation: number) => void;
}

function normalizeAngle(angle: number): number {
  return ((angle % 360) + 360) % 360;
}

export function DocumentRotationField(props: DocumentRotationFieldProps) {
  const { value, onSubmit, disabled } = props;

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 0.5 }}>
      <IconButton
        size="small"
        disabled={disabled}
        onClick={() => onSubmit(normalizeAngle(Math.floor(value / 90) * 90 + 90))}
        sx={{ marginBottom: '4px' }}
      >
        <RotateLeftIcon fontSize="small" />
      </IconButton>

      <AngleField
        sx={{ flex: 1, minWidth: 0, marginBottom: 0 }}
        label="Rotation"
        value={value}
        disableSwitchingDisplayFormat
        onSubmit={(angle) => onSubmit(normalizeAngle(angle))}
      />

      <IconButton
        size="small"
        disabled={disabled}
        onClick={() => onSubmit(normalizeAngle(Math.ceil(value / 90) * 90 - 90))}
        sx={{ marginBottom: '4px' }}
      >
        <RotateRightIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
